import { render, staticRenderFns } from "./CaseRecordDialog.vue?vue&type=template&id=f904e9e4&scoped=true"
import script from "./CaseRecordDialog.vue?vue&type=script&lang=js"
export * from "./CaseRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./CaseRecordDialog.vue?vue&type=style&index=0&id=f904e9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f904e9e4",
  null
  
)

export default component.exports